import { tv } from "tailwind-variants";

export const popoverOffsetForArrow = 8; // Arrow "depth" is half of size-4

export const popoverStyle = tv({
  slots: {
    popover:
      "group/popover min-w-(--trigger-width) origin-(--trigger-anchor-point) rounded-md bg-white shadow-lg ring-1 ring-black/5",
    arrowSvg:
      "block size-4 group-placement-left/popover:-rotate-90 group-placement-right/popover:rotate-90 group-placement-bottom/popover:rotate-180",
    arrowPath: "fill-white stroke-black/5",
  },
  variants: {
    // The enter/exit fade-and-scale. Turn it off for popovers that reposition by
    // remounting (e.g. following a moving anchor), where the animation would
    // replay on every move.
    animated: {
      true: {
        popover:
          "transition data-[entering]:scale-95 data-[entering]:opacity-0 data-[entering]:duration-150 data-[exiting]:scale-95 data-[exiting]:opacity-0 data-[exiting]:duration-75",
      },
    },
  },
  defaultVariants: {
    animated: true,
  },
});
